// ============================================================
// InboundStrip - what next round does to this body (v8.259.0).
// One slim banded LINE in the Status tab's footer slot (past it, "+N"): per-turn
// effects (fire), countdowns about to tick or lapse, the death
// clock, regeneration. Display only - the real tick belongs to
// computeCountdownPure, never to this strip.
// ============================================================
import { deriveInboundPreview } from '../engine/inboundPreview';
import type { Target } from '../types';
import BadgeRow from './BadgeRow';
import styles from '../styles/TargetAuspex.module.css';

export default function InboundStrip({ target }: { target: Target }) {
  const items = deriveInboundPreview(target);
  if (items.length === 0) return null;
  const spans = items.map((i) => (
    <span key={i.key} className={styles.stripItem} data-tone={i.tone}>
      {i.label}
    </span>
  ));
  // One line, as the chips above: four timed conditions made four lines and squeezed the plate (2026-10-24).
  return (
    <div className={styles.strip} data-testid="inbound-strip">
      <span className={styles.stripTitle}>INBOUND</span>
      <div className={styles.stripItems}>
        <BadgeRow label="Inbound" full={spans}>
          {spans}
        </BadgeRow>
      </div>
    </div>
  );
}
